__turbopack_context__.v({
  "grid": "results-grid-module-scss-module__8WIraq__grid",
});
